<template>
    <div>
        common 组件测试
    </div>
</template>
<script>
export default {
    name:'TestCommon',
    data(){
        return {

        }
    }
}
</script>
<style lang="scss" scoped>

</style>
